// biome-ignore lint/style/useImportType: intended
import { type PropsWithChildren } from 'react';

type LayoutDefaultContentProps = PropsWithChildren<{
  className?: string;
}>;

export default function LayoutDefaultContent({
  className,
  children,
}: LayoutDefaultContentProps) {
  return <section className={className || ''}>{children}</section>;
}
